import React from "react";
import { Container, Row, Table, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";
import PageModal from "presentation/components/page-modal";

import CancelButton from "presentation/components/buttons/cancel";
import AddButton from "presentation/components/buttons/add";

import AddStudentModal from "presentation/pages/classrooms/elements/add-student-modal";

import { handleResultData } from "presentation/utils/functions/generic";
import { generateGradesPDF } from "presentation/pages/classrooms/functions/classroom-functions";

import classroomsService from "presentation/services/classrooms";
import classroomsStudentsService from "presentation/services/classroom-students";

import { DROPDOWN_MENU_TYPE_ITEM, DROPDOWN_MENU_TYPE_DIVIDER, reportTypes } from 'presentation/model/constants';
import DropdownMenu from "presentation/components/dropdown-menu/menu";
import RemoveItemTitle from "presentation/components/dropdown-menu/item-title/remove";

import { FileRuled } from 'react-bootstrap-icons';

class ClassroomStudentsMain extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      actionLoading: false,
      error: false,
      message: '',
      data: [],
      classroom: {
        name: ''
      },
      showConfirmModal: false,
      showAddStudentModal: false,
      targetDeleteId: null,
    };
    this.loadData = this.loadData.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
  }

  async componentDidMount() {
    const { id } = this.props.match.params
    await this.loadData(id);
  }

  loadData = async (id) => {

    await classroomsService.findById(id).then((result) => {
      let handledResult = handleResultData(result);

      this.setState({ classroom: handledResult });
    });

    await classroomsStudentsService.search({ classroomId: id }).then((result) => {
      let handledResult = handleResultData(result);

      this.setState({ data: handledResult, loading: false });
    });
  }

  openModal = (id) => {
    this.setState({ targetDeleteId: id, showConfirmModal: true });
  }

  closeModal = () => {
    this.setState({ showConfirmModal: false, targetDeleteId: null });
  }

  openAddStudentModal = () => {
    this.setState({ showAddStudentModal: true });
  }

  closeAddStudentModal = () => {
    this.setState({ showAddStudentModal: false });
  }

  deleteItem = () => {
    const { id } = this.props.match.params
    const { loadData } = this;
    if (this.state.targetDeleteId) {
      this.setState({ loading: true, actionLoading: true });
      classroomsStudentsService.remove(this.state.targetDeleteId).then((result) => {
        this.setState({ loading: false, actionLoading: false, targetDeleteId: null, showConfirmModal: false }, () => {
          loadData(id);
        });
      });
    }
  }



  render() {
    const { id } = this.props.match.params;

    const { loading, actionLoading, error, message, data, showConfirmModal, showAddStudentModal, classroom } = this.state;

    const { deleteItem, closeModal, openModal, openAddStudentModal, closeAddStudentModal, loadData } = this;

    const component = this;

    return (
      <div>
        {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
        {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
        {loading === false && error === false && data.length <= 0 && <PageAlert className="m-b-20" message={"Sem informações"} description={"Não há dados para exibir no momento..."} type="info" dismissible />}
        {loading === false && (
          <Container>
            <Row>
              <h4>
                Alunos da turma {classroom.name}
                <AddButton
                  containerProps={{
                    onClick: () => openAddStudentModal()

                  }}
                />
              </h4>
              <Container>
                <Table className="mt-4">
                  <thead>
                    <tr>
                      <th>Matrícula</th>
                      <th>Nome</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.length > 0 && data.map((element, index) => {
                      return (
                        <tr key={element.id}>
                          <td>{element.student.registration}</td>
                          <td>{element.student.person.name}</td>
                          <td className="text-end">
                            <DropdownMenu
                              items={[
                                { type: DROPDOWN_MENU_TYPE_ITEM, title: <><FileRuled /> Boletim</>, props: { onClick: () => generateGradesPDF(component, { reportType: reportTypes.StudentGrades, classroomId: classroom.id, studentId: [element.student.id] }) } },
                                { type: DROPDOWN_MENU_TYPE_ITEM, title: <RemoveItemTitle />, props: { onClick: () => openModal(element.id) } }
                              ]}
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Container>
              <div className="mt-3">
                <CancelButton
                  containerProps={{
                    as: Link,
                    to: `/turmas`
                  }}
                />
              </div>
            </Row>
            <AddStudentModal
              show={showAddStudentModal}
              onClose={closeAddStudentModal}
              loadData={loadData}
              entityId={id}
              entityName={classroom.name}
            />
            <PageModal
              show={showConfirmModal}
              onClose={closeModal}
              onConfirm={deleteItem} />
          </Container>
        )}
      </div>
    );
  };
}

export default ClassroomStudentsMain;
